@if (initialized()) {

    <pandora-notification-container />
    <app-drawer-container />
    <app-modal-container />

    @if (organization(); as organization) {
        <app-header />
    }

    <div class="flex flex-col flex-grow">
        <router-outlet />
    </div>
} @else {
    <div class="flex justify-center py-24">
        <pandora-spinner />
    </div>
}

<p-toast
    [autoZIndex]="true"
    [position]="'bottom-left'"
/>
